function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDomainRoom = function SvgDomainRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 0c11 0 20 9 20 20s-9 20-20 20S0 31 0 20 9 0 20 0z",
    style: {
      fill: "#8b9c8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3 11.4c.8-.3 1.7-.4 2.7-.4 3.5 0 6.6 2 8.1 5 .6 1.2.9 2.6.9 4 0 2.7-1.2 5.1-3 6.7-.1.1-.2.2-.3.2-1.5 1.3-3.5 2.1-5.7 2.1-3.4 0-6.4-1.9-7.9-4.7C11.4 23 11 21.5 11 20c0-4 2.7-7.5 6.3-8.6zM19.9 27c1-1.5.6-4-.9-4-2 0-2-1-2-2 0-.8-2-1-3-1-.2-1 0-3 2-3 1.5 0 2-.5 2-1.5s.5-1.5 1.5-1.5c.9 0 1.6-.3 2-.8-.5-.1-1-.2-1.5-.2-3.9 0-7 3.1-7 7 0 3.8 3.1 6.9 6.9 7zm5-2.1c-.4-.4-.9-.9-.9-1.9 0-.5-.5-1-1-1-1.5 0-2-.5-2-2 0-1.2 1.3-1.8 2-2 0-.7.4-2 2-2h.7c.8 1.1 1.3 2.5 1.3 4 0 1.9-.8 3.7-2.1 4.9z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fff"
    }
  }));
};
export default SvgDomainRoom;